import moment from 'moment';
import { formatItalianNumber } from './engine';

/**
 * Tag disponibili per template: template_order_supplier
 *
 * TESTATA:
 *   {orderTitle}       - Titolo ordine (C/Lavoro, Materia Prima, ecc.)
 *   {internalCode}     - Codice interno ordine
 *   {date}             - Data ordine (DD/MM/YYYY)
 *   {supplierName}     - Nome fornitore
 *   {supplierAddress}  - Indirizzo fornitore
 *   {supplierVat}      - P.IVA fornitore
 *   {supplierPhone}    - Telefono fornitore
 *   {supplierEmail}    - Email fornitore
 *   {externalCode}     - Codice esterno
 *   {deliveryAddress}  - Indirizzo di consegna
 *   {warehouseStart}   - Magazzino partenza
 *   {warehouseFinish}  - Magazzino arrivo
 *   {paymentCondition} - Condizione di pagamento
 *   {deliveryDate}     - Data consegna (DD/MM/YYYY)
 *   {transportBy}      - Trasporto a cura di
 *   {itemsAspect}      - Aspetto dei beni
 *   {notesOrder}       - Note ordine
 *   {vatCondition}     - Condizione IVA
 *
 * RIGHE (loop {#rows}...{/rows}):
 *   {pos}          - Posizione riga
 *   {code}         - Codice articolo
 *   {description}  - Descrizione
 *   {um}           - Unita di misura
 *   {quantity}     - Quantita
 *   {price}        - Prezzo unitario
 *   {discount}     - Sconto (combinato discount1+discount2+discount3)
 *   {total}        - Totale riga
 *   {expectedDate} - Data prevista
 *   {notes}        - Note riga
 *
 * TOTALI:
 *   {weight}          - Peso totale
 *   {totalImponibile} - Totale imponibile
 *   {totalIva}        - Totale IVA
 *   {totalPrice}      - Totale ordine
 */

function getOrderTitle(typeOrder) {
    const v = typeOrder?.value || typeOrder;
    if (v === '0_CONTO_LAVORO') return 'Ordine C/Lavoro';
    if (v === '5_MATERIA_PRIMA') return 'Ordine Materia Prima';
    if (v === '10_PRODUZIONE_INTERNA') return 'Ordine Prod. Interna';
    return 'Ordine Fornitore';
}

function getItemsAspect(val) {
    if (!val) return '-';
    const v = val.value || val;
    if (v === '0_SCATOLE') return 'Scatole';
    if (v === '5_VISTA') return 'A Vista';
    if (v === '10_PLURIBOL') return 'Pluribol';
    if (v === '15_CARTONI') return 'Cartoni';
    return v;
}

function getTransportBy(val) {
    if (!val) return '-';
    const v = val.value || val;
    if (v === '0_SENDER') return 'Mittente';
    if (v === '1_RECIPIENT') return 'Destinatario';
    if (v === '2_CARRIER') return 'Vettore';
    return '-';
}

function formatDiscount(row) {
    let parts = [];
    if (row.discount1 && parseFloat(row.discount1) !== 0) parts.push(row.discount1);
    if (row.discount2 && parseFloat(row.discount2) !== 0) parts.push(row.discount2);
    if (row.discount3 && parseFloat(row.discount3) !== 0) parts.push(row.discount3);
    return parts.length > 0 ? parts.join('+') + '%' : '';
}

export default {
    tags: {
        internalCode: 'internalCode',
        date: { path: 'date', format: 'date' },
        supplierName: 'idSupplier.name',
        supplierAddress: 'idSupplier.address',
        supplierVat: 'idSupplier.vatNumber',
        supplierPhone: 'idSupplier.phone',
        supplierEmail: 'idSupplier.email',
        externalCode: { path: 'externalCode', default: '-' },
        deliveryAddress: { paths: ['address.address', 'address.address'], default: '-' },
        warehouseStart: { path: 'idWarehouseStart.name', default: '-' },
        warehouseFinish: { path: 'idWarehouseFinish.name', default: '-' },
        paymentCondition: { path: 'idPaymentCondition.name', default: '-' },
        deliveryDate: { path: 'deliveryDate', format: 'date', default: '-' },
        notesOrder: 'notes',
        vatCondition: { path: 'idVatCondition.name', default: '-' },
        vatPercentage: { compute: (data) => data.idVatCondition?.percentage != null ? data.idVatCondition.percentage + '%' : '' },
    },

    rows: {
        source: 'rows',
        tags: {
            pos: '_index',
            code: 'idItemModel.code',
            description: { paths: ['name', 'idItemModel.name'] },
            um: { paths: ['measureUnit', 'idItemModel.idMeasureUnit.symbol'], default: 'NR' },
            quantity: { path: 'quantity', format: 'number:0', default: '1' },
            price: { path: 'price', format: 'currency:2' },
            discount: { compute: (row) => formatDiscount(row) },
            total: { path: 'total', format: 'currency:2' },
            expectedDate: { path: 'expectedDate', format: 'date:DD/MM/YY' },
            notes: 'notes',
        }
    },

    computed: (data) => {
        let totalWeight = 0;
        (data.rows || []).forEach(row => { totalWeight += parseFloat(row.grossWeight || 0); });
        return {
            orderTitle: getOrderTitle(data.typeOrder),
            transportBy: getTransportBy(data.transportBy),
            itemsAspect: getItemsAspect(data.itemsAspect),
            totalWeight: formatItalianNumber(data.weight || totalWeight || 0, 3),
            totalImponibile: formatItalianNumber(data.totalImponibile || 0, 2) + ' €',
            totalIva: formatItalianNumber(data.totalIva || 0, 2) + ' €',
            totalPrice: formatItalianNumber(data.totalPrice || 0, 2) + ' €',
        };
    }
};
